export default __webpack_public_path__ + "static/media/83.fb17142c.png";